<template>
  <div>
    <vx-card title="Житель" class="p-6 mb-5">
      <div class="vx-row flex-wrap">
        <div class="vx-col flex-1">
          <table class="w-full" v-if="user">
            <tr>
              <td class="font-semibold">Последний вход</td>
              <td class="pl-4 py-1">
                <span>{{ user.last_login }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Роль</td>
              <td class="pl-4 py-1">
                <span>{{ user.user_role.name }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Статус</td>
              <td class="pl-4 py-1 w-6/12">
                <v-select
                  v-if="user.is_active"
                  @input="changeUserStatus"
                  :options="listUserStatus"
                  :clearable="false"
                  label="name"
                  style="background-color: #fff"
                  placeholder="Статус"
                  v-model="userStatus"
                >
                  <div slot="no-options">Совпадений не найдено</div>
                </v-select>
                <span v-else class="text-danger">Номер не подтвержден</span>
              </td>
            </tr>
          </table>
        </div>
        <div class="vx-col flex-1">
          <table class="w-full" v-if="user">
            <tr>
              <td class="font-semibold">ФИО</td>
              <td class="pl-4 py-1">
                <span>{{ user.full_name }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Телефон</td>
              <td class="pl-4 py-1">
                <a :href="`tel:${user.phone}`" class="text-primary">{{
                  user.phone
                }}</a>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Email</td>
              <td class="pl-4 py-1">
                <a :href="`mailto:${user.email}`" class="text-primary">{{
                  user.email
                }}</a>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">О себе</td>
              <td class="pl-4 py-1">
                <span>{{ user.bio }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Лицевой счет</td>
              <td class="pl-4 py-1">
                <template v-if="user.personal_accounts.length > 0">
                  <span
                    v-for="(account, index) in user.personal_accounts"
                    :key="index"
                  >
                    <router-link
                      v-if="index + 1 == user.personal_accounts.length"
                      :to="{
                        name: 'communal-payments-personal-account',
                        params: { id: account.id },
                      }"
                    >
                      {{ account.account }}
                    </router-link>
                    <router-link
                      v-else
                      :to="{
                        name: 'communal-payments-personal-account',
                        params: { id: account.id },
                      }"
                    >
                      {{ account.account }},
                    </router-link>
                  </span>
                </template>
                <template v-else>
                  <p class="text-warning">Отсутствует</p>
                </template>
                <vs-button
                  @click="popupAddPA = true"
                  class="block mt-2"
                  size="small"
                  color="primary"
                >
                  Добавить ЛС
                </vs-button>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <template slot="footer">
        <vs-button @click="popupEditUser = true" class="mr-3" color="success">
          Изменить
        </vs-button>
        <vs-button @click="popupDeleteComfirm = true" color="danger">
          Удалить
        </vs-button>
      </template>
    </vx-card>

    <vs-row class="-mx-3 w-auto">
      <vs-col vs-lg="6" vs-sm="12" vs-xs="12" class="px-3 mb-5">
        <vx-card title="Участки" class="p-6 h-full">
          <template v-if="user && user.homes.length">
            <vs-list>
              <vs-list-item
                v-for="(home, index) in user.homes"
                :key="index"
                :title="`${index + 1}. ${home.county_type.name}, участок #${
                  home.homestead_number
                }`"
                :subtitle="`Улица ${home.address}`"
              >
                <vx-tooltip class="inline-block" text="Удалить">
                  <vs-button
                    v-if="user.homes.length > 1"
                    @click="deleteHome(home)"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    color="danger"
                    size="small"
                  ></vs-button>
                </vx-tooltip>
              </vs-list-item>
            </vs-list>
          </template>
          <template v-else> Список участков пуст </template>
          <template slot="footer">
            <vs-button @click="getHomes" class="mr-3" color="primary">
              Добавить
            </vs-button>
          </template>
        </vx-card>
      </vs-col>

      <vs-col vs-lg="6" vs-sm="12" vs-xs="12" class="px-3 mb-5">
        <vx-card title="Члены семьи" class="p-6 h-full">
          <template v-if="user && user.family.length">
            <vs-list>
              <vs-list-item
                v-for="(member, index) in user.family"
                :key="index"
                :title="`${index + 1}. ${member.full_name}`"
                :subtitle="`Телефон: ${member.phone}`"
              >
                <vx-tooltip class="inline-block mr-3" text="Изменить">
                  <vs-button
                    @click="openUpdateFamilyMember(member.id)"
                    icon-pack="feather"
                    icon="icon-edit"
                    color="primary"
                    size="small"
                  ></vs-button>
                </vx-tooltip>
                <vx-tooltip class="inline-block" text="Удалить">
                  <vs-button
                    @click="deleteFamilyMember(member.id)"
                    icon-pack="feather"
                    icon="icon-trash-2"
                    color="danger"
                    size="small"
                  ></vs-button>
                </vx-tooltip>
              </vs-list-item>
            </vs-list>
          </template>
          <template v-else> Список членов семьи пуст </template>
          <template slot="footer">
            <vs-button
              @click="popupFamilyMember = true"
              class="mr-3"
              color="primary"
            >
              Добавить
            </vs-button>
          </template>
        </vx-card>
      </vs-col>
    </vs-row>

    <vs-popup
      v-if="user"
      title="Вы действительно хотите удалить?"
      :active.sync="popupDeleteComfirm"
    >
      <p class="font-semibold mb-5">
        Житель
        <span class="text-danger text-lg">{{ user.full_name }}</span>
        будет удален безвозвратно
      </p>
      <vs-button @click="deleteUser" color="danger" class="mr-5" type="filled"
        >Удалить</vs-button
      >
      <vs-button @click="popupDeleteComfirm = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>

    <vs-popup
      v-if="user && homes"
      title="Добавить участок"
      :active.sync="popupAddHome"
      v-on:close="clearSelectedHome"
    >
      <p class="font-semibold mb-5">Выберите участок</p>

      <div class="flex flex-wrap items-center justify-between w-full">
        <div class="header-filter md:w-6/12 md:px-2 w-full mb-2 cursor-pointer">
          <vs-input
            class="w-full"
            placeholder="Номер участка"
            v-model="filter.homestead_number"
          />
        </div>

        <div class="header-filter md:w-6/12 md:px-2 w-full mb-2 cursor-pointer">
          <v-select
            @input="filterHomes"
            label="name"
            :options="countyType"
            :reduce="(name) => name.id"
            :clearable="true"
            v-model="filter.county_type"
            placeholder="Выбор поселения"
            style="background-color: #fff"
          >
            <div slot="no-options">Совпадений не найдено</div>
          </v-select>
        </div>
      </div>

      <vs-table :data="homes" v-model="selectedHome">
        <template slot="thead">
          <vs-th> Участок </vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr
            :state="ifHomeSelected(tr.id) ? null : 'success'"
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
          >
            <vs-td>
              <span class="text-primary">{{ tr.county_type.name }}</span
              >, участок #
              <span class="text-primary">{{ tr.homestead_number }}</span
              >, ул. <span class="text-primary">{{ tr.address }}</span>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <vs-pagination
        v-if="totalPagePagination > 1"
        class="mt-4"
        :total="totalPagePagination"
        v-model="currentPagingationPage"
      ></vs-pagination>
      <vs-button
        @click="addHome"
        :disabled="!validateAddSelectHome"
        color="success"
        class="mt-5"
        type="filled"
        >Добавить</vs-button
      >
    </vs-popup>

    <vs-popup
      :title="familyMember.id ? 'Изменить члена семьи' : 'Добавить члена семьи'"
      :active.sync="popupFamilyMember"
      v-on:close="clearFamilyMember"
    >
      <vs-input
        class="w-full mb-4"
        name="ФИО"
        label="ФИО"
        v-validate="'required'"
        v-model="familyMember.full_name"
      />
      <span class="text-danger text-sm block">{{ errors.first("ФИО") }}</span>

      <vs-input
        class="w-full mb-4"
        name="Телефон"
        label="Телефон"
        v-validate="'required|length:12'"
        v-mask="'+###########'"
        v-model="familyMember.phone"
      />
      <span class="text-danger text-sm block">{{
        errors.first("Телефон")
      }}</span>

      <div class="popup-footer mt-4">
        <vs-button
          v-if="!familyMember.id"
          @click="addNewFamilyMember"
          :disabled="!validateAddFamilyMember"
          color="primary"
          class="mr-5"
          type="filled"
          >Добавить</vs-button
        >
        <vs-button
          v-else
          @click="updateFamilyMember"
          color="primary"
          class="mr-5"
          type="filled"
          >Обновить</vs-button
        >
      </div>
    </vs-popup>

    <vs-popup
      v-if="user"
      title="Добавить лицевой счет"
      :active.sync="popupAddPA"
      v-on:close="clearPersonalAccount"
    >
      <vs-input
        class="w-full mb-4"
        label="ЛС"
        name="ЛС"
        v-model="personalAccount.account"
      />

      <vs-input
        class="w-full mb-4"
        v-validate="'required'"
        label="Баланс"
        name="Баланс"
        type="number"
        v-model.number="personalAccount.saldo"
      />

      <vs-button
        :disabled="!validateAddPersonalAccount"
        @click="addPersonalAccount"
        color="primary"
        class="mr-5"
        type="filled"
        >Добавить</vs-button
      >
      <vs-button @click="popupAddPA = false" color="dark" type="border"
        >Отмена</vs-button
      >
    </vs-popup>

    <vs-popup
      v-if="user"
      title="Редактирование пользователя"
      :active.sync="popupEditUser"
    >
      <label class="vs-input--label">Роль жителя</label>
      <v-select
        label="name"
        :options="userRole"
        :clearable="false"
        maxHeight="100"
        v-model="user.user_role"
        class="mb-4"
      >
        <div slot="no-options">Совпадений не найдено</div>
      </v-select>

      <vs-input
        class="w-full mb-4"
        label="ФИО"
        name="ФИО"
        v-model="user.full_name"
      />

      <vs-input
        class="w-full mb-4"
        label="Email"
        name="Email"
        v-model="user.email"
      />

      <vs-input
        class="w-full mb-4"
        label="О себе"
        name="О себе"
        v-model="user.bio"
      />

      <div class="popup-footer mt-4">
        <vs-button
          @click="updateUser"
          class="mr-5"
          type="relief"
          color="success"
          >Обновить</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { API_URL, countyType, userRole } from "@/.env";
import { DateTime } from "luxon";

export default {
  data: () => ({
    BASE_URL: API_URL,
    userRole,
    countyType,
    user: null,
    homes: null,
    selectedHome: null,
    personalAccount: {
      account: "",
      saldo: 0,
    },
    familyMember: {},

    filter: {
      county_type: "",
      homestead_number: "",
    },

    currentPagingationPage: 1,
    totalHomes: 0,
    totalPagePagination: 1,

    popupDeleteComfirm: false,
    popupFamilyMember: false,
    popupAddHome: false,
    popupAddPA: false,
    popupEditUser: false,

    listUserStatus: [
      { id: "moderation", name: "На модерации" },
      { id: "confirm", name: "Одобрен" },
      { id: "reject", name: "Отклонен" },
    ],
    userStatus: [],
  }),
  components: {
    DateTime,
  },
  watch: {
    filter: {
      handler(val) {
        this.filterHomes();
      },
      deep: true,
    },
    currentPagingationPage: function () {
      this.getHomes();
    },
  },
  computed: {
    validateAddSelectHome() {
      return (
        this.selectedHome !== null && this.ifHomeSelected(this.selectedHome.id)
      );
    },
    validateAddPersonalAccount() {
      return this.personalAccount.account !== "";
    },
    validateAddFamilyMember() {
      return (
        !this.errors.any() &&
        !_.isEmpty(this.familyMember) &&
        !_.isEmpty(this.familyMember.full_name) &&
        !_.isEmpty(this.familyMember.phone)
      );
    },
  },
  methods: {
    filterHomes: _.debounce(function () {
      this.currentPagingationPage = 1;
      this.getHomes();
    }, 1000),
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    getUser() {
      this.$vs.loading();

      this.$load(async () => {
        let res = (await this.$api.users.getUser(this.$route.params.id)).data;

        res.last_login = DateTime.fromISO(res.last_login).toLocaleString(
          DateTime.DATETIME_SHORT
        );

        res.homes.forEach((home) => {
          home.county_type = countyType.find((x) => x.id == home.county_type);
        });

        res.user_role = userRole.find((x) => x.id == res.user_role);

        if (!res.is_confirmed && res.in_consideration)
          this.userStatus = this.listUserStatus.find(
            (x) => x.id == "moderation"
          );
        else if (!res.is_confirmed && !res.in_consideration)
          this.userStatus = this.listUserStatus.find((x) => x.id == "reject");
        else if (res.is_confirmed && !res.in_consideration)
          this.userStatus = this.listUserStatus.find((x) => x.id == "confirm");

        this.user = res;
        this.$vs.loading.close();
      });
    },
    deleteUser() {
      this.$load(async () => {
        await this.$api.users
          .deleteUser(this.$route.params.id)
          .then((response) => {
            if (response.status == 200) {
              this.popupDeleteComfirm = false;
              this.notification("Успешно", "Житель удален", "success");
              this.$router.push({ name: "residents" });
            } else {
              this.notification(
                "Ошибка",
                "Не удалось удалить жителя",
                "danger"
              );
            }
          });
      });
    },
    changeUserStatus(status) {
      let payload = {};

      if (status.id == "moderation") {
        payload.is_confirmed = false;
        payload.in_consideration = true;
      } else if (status.id == "reject") {
        payload.is_confirmed = false;
        payload.in_consideration = false;
      } else if (status.id == "confirm") {
        payload.is_confirmed = true;
        payload.in_consideration = false;
      }

      this.$load(async () => {
        await this.$api.users
          .updateUser(this.user.id, payload)
          .then((response) => {
            this.notification(
              "Успешно",
              `Статус жителя изменен на ${status.name} `,
              "success"
            );
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось изменить статус жителя",
              "danger"
            );
          });
      });
    },

    //Family
    addNewFamilyMember() {
      let payload = [
        {
          user: this.user.id,
          full_name: this.familyMember.full_name,
          phone: this.familyMember.phone,
          kind: "any",
        },
      ];

      this.$load(async () => {
        await this.$api.users
          .addFamilyMember(payload)
          .then((response) => {
            response.data.forEach((member) => {
              this.user.family.push(member);
            });

            this.notification(
              "Успешно",
              "Новый член семьи добавлен",
              "success"
            );
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось добавить члена семьи",
              "danger"
            );
          });
      });

      this.popupFamilyMember = false;
    },
    openUpdateFamilyMember(idMember) {
      this.familyMember = this.user.family.find((x) => x.id == idMember);
      this.popupFamilyMember = true;
    },
    updateFamilyMember() {
      let payload = {
        full_name: this.familyMember.full_name,
        phone: this.familyMember.phone,
      };

      this.$load(async () => {
        await this.$api.users
          .updateFamilyMember(this.familyMember.id, payload)
          .then((response) => {
            this.notification("Успешно", "Член семьи обновлен", "success");
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось обновить члена семьи",
              "danger"
            );
          });
      });

      this.popupFamilyMember = false;
    },
    deleteFamilyMember(idMember) {
      this.$load(async () => {
        await this.$api.users
          .deleteFamilyMember(idMember)
          .then((response) => {
            let item = this.user.family.find((x) => x.id == idMember),
              index = this.user.family.indexOf(item);

            if (index !== -1) {
              this.user.family.splice(index, 1);
            }
            this.notification("Успешно", "Член семьи удален", "success");
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось удалить члена семьи",
              "danger"
            );
          });
      });
    },
    clearFamilyMember() {
      this.familyMember = {};
    },
    //End Family

    //Homes
    addHome() {
      let idHomes = [],
        idNewHome = this.selectedHome.id;

      this.user.homes.forEach((item) => {
        idHomes.push(item.id);
      });

      idHomes.push(idNewHome);

      this.$load(async () => {
        await this.$api.users
          .updateUser(this.user.id, { homes: idHomes })
          .then((response) => {
            this.user.homes.splice(0, 0, this.selectedHome);

            this.notification("Успешно", "Новый участок добавлен", "success");
          })
          .catch((error) => {
            this.notification(
              "Ошибка",
              "Не удалось добавить участок",
              "danger"
            );
          });
      });

      this.popupAddHome = false;
    },
    ifHomeSelected(idHome) {
      return this.user.homes.findIndex((x) => x.id == idHome) == -1;
    },
    deleteHome(home) {
      let payload = {
        homes: [],
      };

      this.user.homes.forEach((item) => {
        if (item.id !== home.id) payload.homes.push(item.id);
      });

      this.$load(async () => {
        await this.$api.users
          .updateUser(this.user.id, payload)
          .then((response) => {
            let index = this.user.homes.indexOf(home);

            if (index !== -1) {
              this.user.homes.splice(index, 1);
            }

            this.notification("Успешно", "Участок удален", "success");
          })
          .catch((error) => {
            this.notification("Ошибка", "Не удалось удалить участок", "danger");
          });
      });
    },
    getHomes() {
      this.$vs.loading();

      this.filter.page = this.currentPagingationPage;
      this.filter.limit = 10;

      this.$load(async () => {
        await this.$api.homes
          .getHomes(this.filter)
          .then((res) => {
            this.totalHomes = res.data.count;

            this.totalPagePagination = Math.ceil(
              this.totalHomes / this.filter.limit
            );

            let homes = res.data.results;

            homes.forEach((home, i) => {
              home.county_type = countyType.find(
                (x) => x.id == home.county_type
              );
            });

            this.homes = homes;
            this.$vs.loading.close();
            this.popupAddHome = true;
          })
          .catch((error) => {
            console.log(error);
            this.$vs.loading.close();
          });
      });
    },
    clearSelectedHome() {
      this.selectedHome = null;
    },
    //End Homes

    //Add PersonalAccount
    addPersonalAccount() {
      let payload = {
        user: this.user.id,
        account: this.personalAccount.account,
        saldo: this.personalAccount.saldo,
      };

      this.$load(async () => {
        try {
          let response = await this.$api.personalAccounts.createAccount(
            payload
          );

          this.user.personal_accounts.push(response.data);

          this.notification("Успешно", "Лицевой счет создан", "success");

          this.clearPersonalAccount();
          this.popupAddPA = false;
        } catch (error) {
          this.notification(
            "Ошибка",
            "Не удалось создать Лицевой счет",
            "danger"
          );
        }
      });
    },
    clearPersonalAccount() {
      this.personalAccount = {
        account: "",
        saldo: 0,
      };
    },
    //End Add PersonalAccount

    updateUser() {
      let payload = {
        user_role: this.user.user_role.id,
        full_name: this.user.full_name,
        email: this.user.email,
        bio: this.user.bio,
      };

      this.$load(async () => {
        await this.$api.users
          .updateUser(this.user.id, payload)
          .then((response) => {
            this.notification("Успешно", "Житель обновлен", "success");
          })
          .catch((error) => {
            this.notification("Ошибка", "Не удалось обновить жителя", "danger");
          });
      });

      this.popupEditUser = false;
    },
  },
  mounted() {
    this.getUser();
  },
};
</script>